export default __webpack_public_path__ + "static/media/FG_23.b05d7af6.jpg";